import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';


@Component({
  selector: 'app-white-paper',
  templateUrl: './white-paper.component.html',
  styleUrls: ['./white-paper.component.scss']
})
export class WhitePaperComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object

  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function(){});
      $.getScript('../../../../node_modules/slick-carousel/slick/slick.min.js', function () { });
      $.getScript('../../../assets/js/WhitePaper.js', function () { });
    }
    this.titleService.setTitle('[白皮书]Trinka与Grammarly、LanguageTool在学术文件上的比较');
    this.metaTagService.updateTag({ name: 'description', content: '下载白皮书，了解Trinka与Grammarly Premium、LanguageTool在学术文件上的比较。' });
    this.metaTagService.updateTag({ property: 'og:title', content: '[白皮书]Trinka与Grammarly、LanguageTool在学术文件上的比较' });
    this.metaTagService.updateTag({ property: 'og:description', content: '下载白皮书，了解Trinka与Grammarly Premium、LanguageTool在学术文件上的比较。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/trinka-vs-grammarly-vs-language-tool' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinka-vs-grammarly-vs-language-tool' });

  }
  ngAfterViewInit() {

  }
}
